import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "flex flex-row justify-between items-center max-w-full borderline-bottom pb-3" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("em", { class: "fa fa-chevron-left mr-1 text-sm cursor-pointer" }, null, -1);
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = { class: "w-full text-md text-primary font-bold flex flex-row items-center pr-2" };
const _hoisted_5 = ["value"];
const _hoisted_6 = { class: "flex flex-row items-center pr-2" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-pen cursor-pointer" }, null, -1);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-file-export cursor-pointer" }, null, -1);
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
}, null, -1);
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { class: "flex flex-col" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "max-w-full mt-4" }, [
        /*#__PURE__*/ _createElementVNode("h2", { class: "font-bold pb-2 text-sm truncate font-noto" }, "Details"),
        /*#__PURE__*/ _createElementVNode("span", { class: "line" })
    ])
], -1);
const _hoisted_14 = { class: "py-4" };
const _hoisted_15 = { class: "grid grid-cols-12 grid-row items-center text-sm" };
const _hoisted_16 = { class: "text-gray-600 col-span-6" };
const _hoisted_17 = { class: "col-span-6" };
const _hoisted_18 = { class: "grid grid-cols-12 grid-row items-center text-sm" };
const _hoisted_19 = { class: "text-gray-600 col-span-6" };
const _hoisted_20 = { class: "col-span-6" };
const _hoisted_21 = { class: "col-span-12 pt-5" };
const _hoisted_22 = {
    key: 0,
    disabled: "",
    style: { "resize": "none" },
    rows: "4",
    maxlength: "200"
};
const _hoisted_23 = {
    key: 1,
    class: "text-gray-600 text-sm break-words overflow-ellipsis"
};
const _hoisted_24 = { class: "flex flex-col overflow-hidden h-full" };
const _hoisted_25 = { class: "flex" };
const _hoisted_26 = { class: "flex flex-col font-bold capitalize items-center font-noto" };
const _hoisted_27 = { class: "flex flex-row w-full ml-3 items-center" };
const _hoisted_28 = ["title"];
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
}, null, -1);
const _hoisted_30 = [
    _hoisted_29
];
const _hoisted_31 = ["title"];
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-trash h-5 w-5 cursor-pointer" }, null, -1);
const _hoisted_33 = [
    _hoisted_32
];
const _hoisted_34 = { class: "overflow-hidden h-full" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_avatar = _resolveComponent("avatar");
    const _component_admin_user_vault_overview = _resolveComponent("admin-user-vault-overview");
    const _component_details_sidebar = _resolveComponent("details-sidebar");
    const _component_add_user_to_workspace_modal = _resolveComponent("add-user-to-workspace-modal");
    const _component_remove_user_modal = _resolveComponent("remove-user-modal");
    const _component_edit_workspace_modal = _resolveComponent("edit-workspace-modal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_details_sidebar, null, _createSlots({
            header: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('collapse-sidebar'))),
                        class: "mr-2"
                    }, _hoisted_3),
                    _createVNode(_component_avatar, {
                        class: "w-8 h-8 rounded flex justify-center items-center mr-2",
                        "round-size": "full",
                        src: `https://picsum.photos/seed/${_ctx.workspaceDetails.id}/300/300`
                    }, null, 8, ["src"]),
                    _createElementVNode("span", _hoisted_4, [
                        _createElementVNode("input", {
                            class: "font-bold text-lg focus:none focus:none outline:none border-none rounded-md truncate pr-1 bg-white",
                            type: "text",
                            disabled: "",
                            value: _ctx.workspaceDetails.name
                        }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        (_ctx.hasSpaceAccess)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "pr-2",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showEditWorkspaceModal = true))
                            }, _hoisted_8))
                            : _createCommentVNode("", true),
                        (_ctx.hasSpaceAccess)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "pr-1",
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.exportVault && _ctx.exportVault(...args)))
                            }, _hoisted_10))
                            : _createCommentVNode("", true),
                        (_ctx.hasSpaceAccess)
                            ? (_openBlock(), _createElementBlock("svg", {
                                key: 2,
                                onClick: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => (_ctx.openVault && _ctx.openVault(...args))),
                                style: { "transform": "rotate(270deg)" },
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-6 w-6 cursor-pointer",
                                viewBox: "0 0 20 20",
                                fill: "currentColor"
                            }, _hoisted_12))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('file.totalFiles')), 1),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.workspaceDetails.totalFiles), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('file.toBeClassified')), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.workspaceDetails.toBeClassified), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        (_ctx.workspaceDetails.notes)
                            ? (_openBlock(), _createElementBlock("textarea", _hoisted_22, _toDisplayString(_ctx.workspaceDetails.notes), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('vault.vaultHasNoNotes')), 1))
                    ])
                ])
            ]),
            _: 2
        }, [
            (_ctx.workspaceDetails)
                ? {
                    name: "content",
                    fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("h2", _hoisted_26, _toDisplayString(_ctx.$t('user.users')), 1),
                                _createElementVNode("div", _hoisted_27, [
                                    (_ctx.hasSpaceAccess)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            title: _ctx.$t('misc.actions.invite')
                                        }, [
                                            (_openBlock(), _createElementBlock("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-5 w-5 cursor-pointer mr-1",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.showAddUserModal = true))
                                            }, _hoisted_30))
                                        ], 8, _hoisted_28))
                                        : _createCommentVNode("", true),
                                    (Object.keys(_ctx.usersToRemove).length > 0)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            title: _ctx.$t('misc.actions.delete'),
                                            onClick: _cache[5] || (_cache[5] =
                                                //@ts-ignore
                                                (...args) => (_ctx.showRemoveUserModal && _ctx.showRemoveUserModal(...args)))
                                        }, _hoisted_33, 8, _hoisted_31))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                                (_openBlock(), _createBlock(_component_admin_user_vault_overview, {
                                    modelValue: _ctx.vaultUsers,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.vaultUsers) = $event)),
                                    onSelectUserToDelete: _ctx.handleClickedUser,
                                    key: _ctx.workspaceDetails.id,
                                    "workspace-details": _ctx.workspaceDetails
                                }, null, 8, ["modelValue", "onSelectUserToDelete", "workspace-details"]))
                            ])
                        ])
                    ])
                }
                : undefined
        ]), 1024),
        (_ctx.showAddUserModal && _ctx.hasSpaceAccess)
            ? (_openBlock(), _createBlock(_component_add_user_to_workspace_modal, {
                "selected-space": _ctx.selectedWorkspace,
                show: _ctx.showAddUserModal,
                "onUpdate:show": _cache[7] || (_cache[7] = ($event) => ((_ctx.showAddUserModal) = $event)),
                key: `${_ctx.selectedWorkspace.id}_${_ctx.showAddUserModal}`,
                onAddSuccess: _ctx.addUsers
            }, null, 8, ["selected-space", "show", "onAddSuccess"]))
            : _createCommentVNode("", true),
        (_ctx.showRemoveUser && _ctx.selectedWorkspace)
            ? (_openBlock(), _createBlock(_component_remove_user_modal, {
                key: 1,
                "selected-workspace": _ctx.selectedWorkspace,
                users: _ctx.usersToRemove,
                show: _ctx.showRemoveUser,
                "onUpdate:show": _cache[8] || (_cache[8] = ($event) => ((_ctx.showRemoveUser) = $event)),
                onDeleteSuccess: _ctx.deleteUser,
                onCleanupList: _cache[9] || (_cache[9] = ($event) => (_ctx.usersToRemove = []))
            }, null, 8, ["selected-workspace", "users", "show", "onDeleteSuccess"]))
            : _createCommentVNode("", true),
        (_ctx.showEditWorkspaceModal)
            ? (_openBlock(), _createBlock(_component_edit_workspace_modal, {
                key: 2,
                workspace: _ctx.workspaceDetails,
                show: _ctx.showEditWorkspaceModal,
                "onUpdate:show": _cache[10] || (_cache[10] = ($event) => ((_ctx.showEditWorkspaceModal) = $event)),
                onEditSuccess: _ctx.updateWorkspace
            }, null, 8, ["workspace", "show", "onEditSuccess"]))
            : _createCommentVNode("", true)
    ], 64));
}
